import { createContext } from 'react';

export type MenuContextProps = {
  isMenuOpen: boolean;
  // Context can be extended to pass any needed properties
  // relevant to menu opening
  menuContext: { callout: Callout };
  toggleMenu: (menuContext?: { callout: Callout }) => void;
};

type Callout = 'switcher' | null;

export const MenuContext = createContext<MenuContextProps>({
  isMenuOpen: false,
  menuContext: { callout: null },
  toggleMenu: () => {},
});
